<template>
<div class="multi-modal-wrapper">
    <Modal
        v-for="modal in activeModals"
        :key="modal.modal"
        :modal="modal"
    />
</div>
</template>

<script>

import Modal from "./Modal";
import {mapGetters} from "vuex";
export default {
    name: "MultiModal",
    components:{
        Modal
    },
    computed:{
        ...mapGetters('production_control', ['activeModals'])
    }
}
</script>